import React from "react";
import TagDialog from "./TagDialog";

export default function TagDialogWrapper({
  open,
  onClose,
  onConfirm,
  existingTags
}) {
  if (!open) return null;
  return (
    <TagDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      existingTags={existingTags}
    />
  );
}
